import { render } from "./IngredientEditor.vue?vue&type=template&id=d0c020d0&scoped=true"
import script from "./IngredientEditor.vue?vue&type=script&lang=js"
export * from "./IngredientEditor.vue?vue&type=script&lang=js"

import "./IngredientEditor.vue?vue&type=style&index=0&id=d0c020d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c020d0"]])

export default __exports__